module.exports = __webpack_public_path__ + "static/img/yunyin.34db2b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/homepageImg/yunyin.png
// module id = 723
// module chunks = 87